/* eslint-disable complexity */
import PropTypes from 'prop-types'
import { compose } from 'redux'
import {
  AddItemsCard,
  EcommerceProducts,
  FeedItemTrackingHOC,
  HelloBabyBoxCard,
  LinkAndTransferCard,
  Products,
  RegistryChecklistCard,
  WelcomeCard,
  YouTubeCard,
  TikTokCard,
  InsuranceEligibilityValidatorCard,
} from './feed-items'
import FeedItemCard from './feed-items/FeedItemCard/FeedItemCard'

export const TYPE = {
  ADD_ITEMS: 'addItems',
  ADD_ITEMS_BRANDS: 'addItemsBrands',
  CHECKLIST_QUIZ: 'checklist',
  ECOMMERCE: 'ecommerce',
  GUIDE: 'guide',
  HELLO_BABY_BOX: 'helloBabyBox',
  LINK_AND_TRANSFER: 'linkAndTransfer',
  LINK: 'link',
  PRODUCT_RECOMMENDER: 'productRecommender',
  PRODUCTS: 'products',
  REGISTRY_CHECKLIST: 'registryChecklist',
  SAMPLE_REGISTRY: 'sampleRegistry',
  TIK_TOK: 'tiktok',
  VIDEO: 'video',
  WEEK_BY_WEEK: 'weekByWeek',
  WELCOME: 'welcome',
  YOUTUBE: 'youtube',
  YOUTUBESHORT: 'youtubeShort',
  INSURANCE_ELIGIBILITY_VALIDATOR: 'healthInsuranceVerifier2',
}

export const FeedItemLayout = (props) => {
  const { type } = props

  switch (type) {
    case TYPE.ADD_ITEMS:
      return <AddItemsCard {...props} />
    case TYPE.ADD_ITEMS_BRANDS:
      return <AddItemsCard {...props} />
    case TYPE.ECOMMERCE:
      return <EcommerceProducts {...props} />
    case TYPE.GUIDE:
      return <FeedItemCard {...props} />
    case TYPE.LINK:
      return <FeedItemCard {...props} />
    case TYPE.HELLO_BABY_BOX:
      return <HelloBabyBoxCard {...props} />
    case TYPE.TIK_TOK:
      return <TikTokCard {...props} />
    case TYPE.LINK_AND_TRANSFER:
      return <LinkAndTransferCard {...props} />
    case TYPE.PRODUCTS:
    case TYPE.PRODUCT_RECOMMENDER:
      return <Products {...props} />
    case TYPE.REGISTRY_CHECKLIST:
      return <RegistryChecklistCard {...props} />
    case TYPE.VIDEO:
      const { videoId } = props
      const youtubeUrl = `https://youtube.com/watch?v=${videoId}`

      return <FeedItemCard {...props} linkUrl={youtubeUrl} />
    case TYPE.SAMPLE_REGISTRY:
      return <FeedItemCard {...props} />
    case TYPE.WEEK_BY_WEEK:
      return <FeedItemCard {...props} />
    case TYPE.WELCOME:
      return <WelcomeCard {...props} />
    case TYPE.YOUTUBE:
      return <YouTubeCard {...props} />
    case TYPE.YOUTUBESHORT:
      return <YouTubeCard {...props} />
    case TYPE.INSURANCE_ELIGIBILITY_VALIDATOR:
      return <InsuranceEligibilityValidatorCard {...props} />
    default:
      return null
  }
}

FeedItemLayout.propTypes = {
  type: PropTypes.string.isRequired,
  coregistrations: PropTypes.arrayOf(PropTypes.string),
}

FeedItemLayout.defaultProps = {
  coregistrations: undefined,
}

export default compose(FeedItemTrackingHOC)(FeedItemLayout)
